import { TierRateByYear } from './../../interfaces';

export const rates: TierRateByYear = {
    2019: [ { percentage: 25 } ],
    2020: [ { percentage: 26.25 } ],
    2021: [ { percentage: 26.9 } ],
    2022: [ { percentage: 26.9 } ],
    2023: [
        { to: 67_001, percentage: 24 },
        { percentage: 31 }
    ],
    2024: [
        { to: 67_001, percentage: 24.5 },
        { percentage: 33 }
    ],
};
